import React from 'react';
import axios from 'axios';
import 'react-datetime/css/react-datetime.css';
import { Modal, ModalBody } from 'reactstrap';
import cityTimezones from 'city-timezones';
import moment from 'moment-timezone';
import conference from '../../assets/img/event/conference.jpg'
import virtual from '../../assets/img/event/virtual.jpeg'
import hybrid from '../../assets/img/event/hybrid.jpeg'

import InputField from '../../components/inputs/inputField';
import SelectField from '../../components/inputs/selectField';
import TimeField from '../../components/inputs/timeField';
import ExpandableListItem from '../../components/list/expandableListItem';
import ToggleField from '../../components/inputs/toggleField';
import Dropzone from 'react-dropzone';
import ColorField from '../../components/inputs/colorField';
import LocationLookup from '../../components/inputs/locationLookup';
import CheckboxInput from '../../components/inputs/checkboxInput';
import API from '../../utils/API';
import { ChromePicker } from 'react-color';
import { X } from 'react-feather';


const defaultPermissions = {
    details: { label: "Details", slug: 'details', write: true, read: true },
    attendees: { label: "Attendees", slug: 'attendees', write: true, read: true },
    schedule: { label: "Schedule", slug: 'schedule', write: true, read: true },
    groups: { label: "Groups", slug: 'groups', write: true, read: true },
    inventory: { label: "Inventory", slug: 'inventory', write: true, read: true, addon: 'inventory' },
    emails: { label: "Emails", slug: 'emails', write: true, read: true },
    texting: { label: "Texting", slug: 'texting', write: true, read: true, addon: 'texting' },
    forms: { label: "Forms", slug: 'forms', write: true, read: true },
    pages: { label: "Pages", slug: 'pages', write: true, read: true },
    engagement: { label: "Engagement", slug: 'engagement', write: true, read: true, addon: 'engagement' },
    media: { label: "Media", slug: 'media', write: true, read: true },
    insights: { label: "Insights", slug: 'insights', write: true, read: true },
}

const roles = [
    { label: "Admin", value: "admin" },
    { label: "Organizer", value: "organizer" },
]

let dropzoneLogoRef;
class OnboardingModal extends React.Component {
    constructor(props) {
        super(props);

        const orgBranding = {
            accentColor: props.organization.branding.accentColor,
            fontColor: props.organization.branding.fontColor,
            backgroundColor: props.organization.branding.backgroundColor,
            textColor: props.organization.branding.textColor,
            logo: props.organization.branding.logo,
            favicon: props.organization.branding.favicon,
            fonts: props.organization.branding.fonts.map(f => {
                return {
                    label: f.name,
                    value: f.url
                }
            })
        };

        this.state = {
            sectionCount: 3,
            currentSection: 0,
            nextSectionEnabled: true,
            supportContactEnabled: false,
            supportContactName: props.account.firstName + ' ' + props.account.lastName,
            supportContactEmail: props.account.email,
            orgBranding: orgBranding,
            files: [],
            supportContactEnabled: true,
            teammates: [{
                firstName: "",
                lastName: "",
                email: "",
                role: "",
            }],
            selectedColor: 'background',
            submitting: false,
            invalid: false,
            fontOptions: []
        };
    }

    componentDidMount() {
        //make request to https://www.googleapis.com/webfonts/v1/webfonts?key=

        axios.get(`https://www.googleapis.com/webfonts/v1/webfonts?key=AIzaSyDvDVvkn5-FAGP-pb4vA2azGooK63V2RD8`).then((res) => {
            let fontOptions = [];
            res.data.items.forEach((font) => {
                font.variants.forEach((variant) => {
                    var apiUrl = [];
                    apiUrl.push('https://fonts.googleapis.com/css?family=');
                    apiUrl.push(font.family.replace(/ /g, '+'));
                    apiUrl.push(':');
                    apiUrl.push(variant);
                    const url = apiUrl.join('');
                    fontOptions.push({
                        label: font.family + ' ' + variant,
                        value: url,
                        font: font.family,
                        variant: variant
                    });
                });
            });
            this.setState({ fontOptions });
        }).catch((e) => {
            console.log(e);
        })
    }

    onDrop = (files) => {
        this.setState({
            eventBranding: {
                ...this.state.eventBranding,
                header: files[0]
            }
        });
    };


    onDropLogo = (files) => {
        this.setState({
            eventBranding: {
                ...this.state.eventBranding,
                logo: files[0]
            }
        });
    };

    chooseEventType = (type) => {
        this.setState({
            event: {
                ...this.state.event,
                experienceType: type
            },
            nextSectionEnabled: true
        });
    };

    nextSection = () => {
        const { currentSection } = this.state;
        /* if (currentSection + 1 === 1) {
            this.initializeGeocoder();
            this.initializeMap();
        } */
        this.setState({
            currentSection: currentSection + 1,
            nextSectionEnabled: true
        });
    }

    prevSection = () => {
        const { currentSection } = this.state;
        this.setState({
            currentSection: currentSection - 1,
            nextSectionEnabled: true
        });
    }

    updateEventField = (field, value) => {
        const { event, requiredFields } = this.state;
        event[field] = value;
        let requiredFieldsAcquired = true;
        Object.keys(requiredFields).forEach((key) => {
            if (!event[key] || event[key] === '') {
                requiredFieldsAcquired = false;
            }
        });
        this.setState({ event, nextSectionEnabled: requiredFieldsAcquired, requiredFields });
    }

    updateRole = (role, index) => {
        let eventTeam = this.state.eventTeam;
        eventTeam[index].role = role.value;
        this.setState({ eventTeam: eventTeam })
    }

    onDropLogo = (files) => {
        console.log(files)
        this.uploadFile('logo', files[0]);
    }

    onDropFavicon = (files) => {
        this.uploadFile('favicon', files[0]);
    }

    renderSection = (section) => {
        const { currentSection, supportContactEnabled, teammates, orgBranding, selectedColor, fontOptions } = this.state;
        const { account, organization } = this.props;
        const { logo, favicon, textColor, fontColor, backgroundColor, accentColor, fonts } = orgBranding;

        switch (section) {
            case 0:
                // event type picker
                return <div className={`sectionBody w-100 posAbs anim left ${section == currentSection ? '' : 'closed'}`}>
                    <div className={`headerContainer mb-50 mt-25`}>
                        <div className='text-c'>
                            <h1 className='mb-10'>Welcome to simple.events</h1>
                            <p>Let's get confirm your account.</p>
                        </div>
                    </div>
                    <div className='sectionBlock m-a' style={{ maxWidth: 500 }}>
                        <div className='flex'>
                            <InputField classes="mr-10" label='First Name' value={account.firstName} disabled />
                            <InputField classes="ml-10" label='Last Name' value={account.lastName} disabled />
                        </div>
                        <InputField label='Email' value={account.email} disabled />
                        <InputField label='Company' value={organization.name} disabled />
                        <CheckboxInput label="Use my information as the main contact for all events"
                            onClick={(e) => {
                                this.setState({ supportContactEnabled: !supportContactEnabled })
                            }}
                            checked={supportContactEnabled}

                        />
                        {!supportContactEnabled && <div className='mt-20'>
                            <InputField label="Support Contact Name" value={this.state.supportContactName} onChange={(e) => this.setState({ supportContactName: e.target.value })} />
                            <InputField label="Support Contact Email" value={this.state.supportContactEmail} onChange={(e) => this.setState({ supportContactEmail: e.target.value })} />
                        </div>}
                    </div>
                </div>
            case 1:
                return <div className={`sectionBody w-100 posAbs anim ${section >= currentSection ? 'right' : 'left'} ${section == currentSection ? '' : 'closed'}`}>
                    <div className={`headerContainer mb-50 mt-25`}>
                        <div className='text-c'>
                            <h1 className='mb-10'>Brand</h1>
                            <p>Look how you're supposed to.</p>
                        </div>
                    </div>
                    <div className='sectionBlock m-a' style={{ maxWidth: 500 }}>
                        <div className='mb-30'>
                            <h3>Site Styles</h3>
                            <p>Manage the styles settings that appear accross your company events.</p>
                        </div>
                        <ExpandableListItem
                            initiallyExpanded={true}
                            expandedContent={(state) => <div className={`expandedContentContainer ${!state.expanded ? 'closed' : ''}`} >
                                <div className='flex'>
                                    <div className=' m-20 w-100'>
                                        <p className='small gray mb-10'>Organization Logo</p>
                                        <Dropzone
                                            accept="image/*"
                                            className="clickable dropzone-details"
                                            inputProps={{ style: { margin: 'auto' } }}
                                            ref={(node) => {
                                                dropzoneLogoRef = node;
                                            }}
                                            onDrop={this.onDropLogo.bind(this)}
                                        >
                                            <div className="dropzoneDescriptionContainer">
                                                {logo != "" ? <img className="dropHeaderImage" src={logo} /> : <div className='flex aic jcc column p-20'>
                                                    <i className="las la-plus mb-10" style={{ padding: 10, background: '#F5F6FA', borderRadius: 5 }}></i>
                                                    <p>
                                                        Add Logo
                                                    </p></div>}
                                            </div>
                                        </Dropzone>
                                    </div>
                                    <div className=' m-20 w-100'>
                                        <p className='small gray mb-10'>Favicon</p>
                                        <Dropzone
                                            accept="image/*"
                                            className="clickable dropzone-details"
                                            inputProps={{ style: { margin: 'auto' } }}
                                            ref={(node) => {
                                                dropzoneLogoRef = node;
                                            }}
                                            onDrop={this.onDropFavicon.bind(this)}
                                        >
                                            <div className="dropzoneDescriptionContainer">
                                                {favicon != "" ? <img className="dropHeaderImage" src={favicon} /> : <div className='flex aic jcc column p-20'>
                                                    <i className="las la-plus mb-10" style={{ padding: 10, background: '#F5F6FA', borderRadius: 5 }}></i>
                                                    <p>
                                                        Add Favicon
                                                    </p>
                                                </div>}
                                            </div>

                                        </Dropzone>
                                    </div>
                                </div>
                            </div>
                            }
                            render={(state, props) => <><div className='flex jcsb c-pointer' onClick={props.handleExpand}>
                                <h4>Logos</h4>
                                {!state.expanded ? <i className='las la-angle-down fs-20'></i> : <i className='las la-angle-up fs-20'></i>}
                            </div>
                                <hr className='mt-10' /></>}
                        />
                        <ExpandableListItem
                            initiallyExpanded={false}
                            expandedContent={(state) => <div className={`expandedContentContainer ${!state.expanded ? 'closed' : ''}`} >

                                <div className='flex p-20'>
                                    <ChromePicker
                                        styles={{ default: { picker: { width: '100%', boxShadow: 'none' } } }}
                                        disableAlpha={true}
                                        onChange={(color, event) => {
                                            //onChange(color.hex);
                                            let { orgBranding } = this.state;
                                            switch (selectedColor) {
                                                case 'background':
                                                    orgBranding.backgroundColor = color.hex;
                                                    break;
                                                case 'text':
                                                    orgBranding.fontColor = color.hex;
                                                    break;
                                                case 'button':
                                                    orgBranding.textColor = color.hex;
                                                    break;
                                                case 'accent':
                                                    orgBranding.accentColor = color.hex;
                                                    break;
                                            }
                                            this.setState({ orgBranding });
                                        }}
                                        color={
                                            selectedColor == 'background' ? backgroundColor :
                                                selectedColor == 'text' ? fontColor :
                                                    selectedColor == 'button' ? textColor :
                                                        selectedColor == 'accent' ? accentColor : 'black'

                                        }
                                    />
                                    <div>
                                        <button className={selectedColor == 'background' ? 'neu' : ''} onClick={() => {
                                            this.setState({ selectedColor: 'background' })
                                        }}><div className='circle d25 mr-10 select' style={{ background: backgroundColor }}></div> Background Color</button>
                                        <button
                                            className={selectedColor == 'text' ? 'neu' : ''}
                                            onClick={() => {
                                                this.setState({ selectedColor: 'text' })
                                            }}
                                        ><div className='circle d25 mr-10 select' style={{ background: fontColor }}></div> Primary Text Color</button>
                                        <button
                                            className={selectedColor == 'button' ? 'neu' : ''}
                                            onClick={() => {
                                                this.setState({ selectedColor: 'button' })
                                            }}
                                        ><div className='circle d25 mr-10 select' style={{ background: textColor }}></div> Button Text Color</button>
                                        <button
                                            className={selectedColor == 'accent' ? 'neu' : ''}
                                            onClick={() => {
                                                this.setState({ selectedColor: 'accent' })
                                            }}
                                        ><div className='circle d25 mr-10 select' style={{ background: accentColor }}></div> Accent Color</button>
                                    </div>
                                </div>
                            </div>}
                            render={(state, props) => <><div className='flex jcsb c-pointer' onClick={props.handleExpand}>
                                <h4>Colors</h4>
                                {!state.expanded ? <i className='las la-angle-down fs-20'></i> : <i className='las la-angle-up fs-20'></i>}
                            </div>
                                <hr className='mt-10' /></>}

                        />
                        <ExpandableListItem initiallyExpanded={false}
                            expandedContent={(state) => <div className={`expandedContentContainer ${!state.expanded ? 'closed' : ''}`} >
                                <div className='p-20 mb-50'>
                                    <h3>Preferred Font Family</h3>
                                    <p className='mb-20'>Will be applied to all the pages created on the platform unless explicitly stated otherwise.</p>

                                    <SelectField label="Search Fonts" placeholder="Search Fonts" classes="multi" isMulti={true} options={fontOptions} value={fonts} onChange={(selectedOptions) => {
                                        let { orgBranding } = this.state;
                                        orgBranding.fonts = selectedOptions;
                                        this.setState({ orgBranding });
                                    }} />

                                    {/* <div className='w-100 mt-20'>
                                        <p className='small gray mb-10'>Upload Custom Font</p>
                                        <Dropzone
                                            accept="image/*"
                                            className="clickable dropzone-details"
                                            inputProps={{ style: { margin: 'auto' } }}
                                            ref={(node) => {
                                                dropzoneLogoRef = node;
                                            }}
                                            onDrop={this.onDropFavicon.bind(this)}
                                        >
                                            <div className="dropzoneDescriptionContainer">
                                                {favicon != "" ? <img className="dropHeaderImage" src={favicon} /> : <div className='flex aic jcc column p-20'>
                                                    <i className="las la-plus mb-10" style={{ padding: 10, background: '#F5F6FA', borderRadius: 5 }}></i>
                                                    <p>
                                                        Install Font
                                                    </p>
                                                </div>}
                                            </div>

                                        </Dropzone>
                                    </div> */}
                                </div>
                            </div>}
                            render={(state, props) => <><div className='flex jcsb c-pointer' onClick={props.handleExpand}>
                                <h4>Fonts</h4>
                                {!state.expanded ? <i className='las la-angle-down fs-20'></i> : <i className='las la-angle-up fs-20'></i>}
                            </div>
                                <hr className='mt-10' /></>}
                        />
                    </div>
                </div>
            case 2:
                return <div className={`sectionBody w-100 posAbs anim ${section >= currentSection ? 'right' : 'left'} ${section == currentSection ? '' : 'closed'}`}>
                    <div className={`headerContainer mb-50 mt-25`}>
                        <div className='text-c'>
                            <h1 className='mb-10'>Collaborate</h1>
                            <p>Invite teammates that help bring this together.</p>
                        </div>
                    </div>
                    <div className='sectionBlock m-a' style={{ maxWidth: 500 }}>
                        {teammates.map((teammate, i) => {

                            return <div>
                                <div className='flex'>

                                    <InputField label="First Name"
                                        value={teammate.firstName}
                                        onChange={(e) => this.handleTeammateChange(e, i, 'firstName')}
                                        placeholder="First Name"
                                        classes="mr-10"
                                    />
                                    <InputField label="Last Name"
                                        value={teammate.lastName}
                                        onChange={(e) => this.handleTeammateChange(e, i, 'lastName')}
                                        placeholder="Last Name"
                                        classes="ml-10"
                                    />
                                </div>
                                <InputField label="Email"
                                    value={teammate.email}
                                    onChange={(e) => this.handleTeammateChange(e, i, 'email')}
                                    placeholder="Email"
                                />

                                <SelectField label="Role"
                                    value={teammate.role}
                                    onChange={(e) => this.handleTeammateChange(e, i, 'role')}
                                    placeholder="Role"
                                    options={roles}
                                />
                                <hr />
                            </div>
                        })}
                        <button className="neu" onClick={() => {
                            let { teammates } = this.state;
                            teammates.push({
                                firstName: "",
                                lastName: "",
                                email: "",
                                role: "",
                            });
                            this.setState({ teammates });
                        }}> + Add Teammate</button>
                    </div>
                </div >
            default:
                return;

        }
    }

    handleTeammateChange(e, i, field) {
        let { teammates } = this.state;
        teammates[i][field] = e.target.value;
        this.setState({ teammates });
    }

    uploadFile = async (key, file) => {
        const formData = new FormData();
        formData.append('files', file);
        const res = await API().post(`/Organizations/${this.props.orgId}/assets`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
        if (res.data) {
            this.setState({
                orgBranding: {
                    ...this.state.orgBranding,
                    [key]: res.data.assets[0].url
                }
            });
        }
    }

    submitOrgDetails = async () => {
        const { supportContactName, supportContactEmail, teammates, orgBranding } = this.state;
        const { fontColor, accentColor, backgroundColor, textColor, fonts, logo, favicon } = orgBranding;
        API()
            .patch(`/Organizations/${this.props.orgId}/account`, {
                onboarded: true,
                branding: {
                    logo: logo,
                    favicon: favicon,
                    adminEmail: supportContactEmail,
                    adminEmailName: supportContactName,
                    supportEmail: supportContactEmail,
                    fontColor: fontColor,
                    accentColor: accentColor,
                    backgroundColor: backgroundColor,
                    textColor: textColor,
                    fonts: fonts.map(f => {
                        return {
                            name: f.label,
                            url: f.value
                        }
                    })
                }
            })
            .then((res) => {
                if (res.data) {
                    teammates.forEach((teammate) => {
                        if (teammate.email != "") {
                            API().post(`Organizations/${this.props.orgId}/member`, {
                                firstName: teammate.firstName,
                                lastName: teammate.lastName,
                                emailAddress: teammate.email,
                                permission: teammate.role
                            });
                        }
                    });
                    this.props.toggle();
                }
            })
            .catch((e) => {
                //this.setState({ editing: false, editedAccountData: this.state.accountData });
            });
    }

    dismissModal = () => {
        API()
            .patch(`/Organizations/${this.props.orgId}/account`, {
                onboarded: true,
                branding: {}
            }).then((res) => {
                this.props.toggle();
            })

    }


    render() {
        const { isOpen } = this.props;
        const { nextSectionEnabled, currentSection, sectionCount, submitting } = this.state;

        return (
            <Modal isOpen={isOpen} toggle={this.dismissModal} className="stepSize">
                <div className="modalHeader">
                    <button onClick={this.dismissModal} style={{ position: 'absolute', right: 5, top: 5, padding: 7 }}><i className='las la-times'></i></button>
                </div>
                <ModalBody className="modalBody">
                    {this.renderSection(0)}
                    {this.renderSection(1)}
                    {this.renderSection(2)}
                </ModalBody>
                <div className='flex m-a' style={{ width: '100%' }}>

                    {currentSection == 0 ? <button className="neu ml-a mr-15" onClick={this.dismissModal}>Cancel</button> : <button className="neu ml-a mr-15" onClick={this.prevSection}>Back</button>}
                    {currentSection < sectionCount - 1 ? <button className={`neu  ${nextSectionEnabled ? 'prim' : 'disabled'}`}
                        onClick={this.nextSection}>Next</button> : <button className={`neu ${submitting ? 'disabled' : 'prim'}`} onClick={this.submitOrgDetails}>{submitting ? "Submitting..." : "Finish"}</button>}
                </div>
            </Modal>
        );
    }
}

export default OnboardingModal;
